import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {CreditCardModel} from "../interface/creditCardModel";

@Injectable({
  providedIn: 'root'
})
export class BankCardService {
  private apiUrl =  `${environment.apiUrl}/bank-cards`;

  constructor(
    private http: HttpClient
  ) {
  }

  saveCreditCard(creditCard: CreditCardModel): Observable<CreditCardModel> {
    return this.http.post<CreditCardModel>(this.apiUrl, creditCard);
  }

  deleteBankCard(userId: bigint, id: number): Observable<CreditCardModel> {
    return this.http.delete<CreditCardModel>(`${this.apiUrl}/${userId}?id=${id}`);
  }

  editCreditCard(userId: bigint, id: number): Observable<CreditCardModel> {
    return this.http.put<CreditCardModel>(`${this.apiUrl}/${userId}?id=${id}`, null);
  }
}
